import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 3a1 1 0 0 0-2 0v4H3a1 1 0 0 0 0 2h4v15a1 1 0 0 0 1 1h15v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2H9z"
    />
    <path
      fill="currentColor"
      d="M11 8a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V9H12a1 1 0 0 1-1-1"
    />
  </svg>
);
const SvgIconCrop = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCrop);
export default Memo;
